<template functional>
    <svg class="svg-path svg-path--discover" :style="{
        '--c': props.color,
    }">
        <g>
            <path :d="props.path" />
        </g>
    </svg>
</template>

<script>
export default {
    props: {
        path: String,
        color: {
            type: String,
            default: '#e9e5df'
        },
    },
}
</script>